/**
 * PD-17174 — the click on a real link (`<a href>`) inside a storefront item
 * card. The storefront navigates in place (no page load), so a plain left
 * click is handed to `onNavigate`; a click that asks for a new tab or window
 * (Ctrl/Cmd/Shift/Alt, or any button but the main one) is left to the
 * browser, which is the point of rendering a link at all. Either way the
 * card's own click handler must not run as well, or one click would
 * navigate twice. With no `onNavigate` the browser follows the link.
 *
 * Typed structurally rather than as a React MouseEvent so it can be unit
 * tested with a plain object.
 */
export interface CardLinkClickEventModel {
	button: number;
	metaKey: boolean;
	ctrlKey: boolean;
	shiftKey: boolean;
	altKey: boolean;
	defaultPrevented: boolean;
	preventDefault: () => void;
	stopPropagation: () => void;
}

export function handleCardLinkClick(
	event: CardLinkClickEventModel,
	onNavigate?: () => void,
): void {
	event.stopPropagation();
	if (onNavigate == null || event.defaultPrevented) {
		return;
	}
	const opensElsewhere =
		event.button !== 0 ||
		event.metaKey ||
		event.ctrlKey ||
		event.shiftKey ||
		event.altKey;
	if (opensElsewhere) {
		return;
	}
	event.preventDefault();
	onNavigate();
}
